const validEmail = (s: string) => /^[a-z0-9æøå_.+-]+@[a-z0-9æøå.-]+\.[a-z]{2,}$/i.test(s);

export default validEmail;